import { Response } from "@/models/continente-credentials/common/Response";
import { CardValidation } from "@/models/continente-credentials/mobile/CardValidation";
import { CardValidationResponse } from "@/models/continente-credentials/mobile/CardValidationResponse";

export interface ICardValidationService {
  cardValidation(
    cardValidation: CardValidation,
    cardValidationUrl: string
  ): Promise<Response<CardValidationResponse>>;
}

export class CardValidationService implements ICardValidationService {
  async cardValidation(
    cardValidation: CardValidation,
    cardValidationUrl: string
  ): Promise<Response<CardValidationResponse>> {
    const resp = await fetch(cardValidationUrl, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cardValidation),
    });

    if (resp.ok) {
      return { kind: "success", value: await resp.json() };
    } else if (resp.status === 400) {
      const error = await resp.json();

      const returnedError = error.find((c: any) => c.Code != null);
      return {
        kind: "error",
        code: returnedError.Code ? returnedError.Code : 0,
        message: returnedError.message ? returnedError.message : "",
      };
    } else {
      return {
        kind: "unexpected_error",
      };
    }
  }
}

export const cardValidationService = new CardValidationService();
